var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('img',{attrs:{"src":require(`@/assets/${_vm.image}`)}}),_c('div',{staticClass:"text"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2),_c('router-link',{attrs:{"id":"next","to":_vm.link}},[_c('button',[_vm._v("Read the Case Study")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }